import type { AnyAction, Middleware } from '@reduxjs/toolkit'
import * as Sentry from '@sentry/react'

const SENTRY_BREADCRUMB_ACTIONS = new Set<string>([
    'auth/login/fulfilled',
    'auth/login/rejected',
    'auth/logout/fulfilled',
    'auth/logout/rejected',
])

export const sentryMiddleware: Middleware = (storeAPI) => (next) => (action) => {
    const typedAction = action as AnyAction
    const actionType = typeof typedAction.type === 'string' ? typedAction.type : null

    try {
        const result = next(action)

        if (actionType) {
            const normalizedType = actionType.toLowerCase()
            if (SENTRY_BREADCRUMB_ACTIONS.has(normalizedType)) {
                Sentry.addBreadcrumb({
                    category: 'redux',
                    message: `Action: ${actionType}`,
                    level: 'info',
                    data: { action: actionType },
                })
            }
        }

        return result
    } catch (error) {
        Sentry.captureException(error, {
            tags: { source: 'redux-middleware' },
            extra: {
                action: actionType ?? 'unknown',
                stateSlices: (() => {
                    if (!storeAPI.getState) {
                        return []
                    }
                    const state = storeAPI.getState()
                    return state && typeof state === 'object' ? Object.keys(state as Record<string, unknown>) : []
                })(),
            },
        })
        throw error
    }
}
